import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'layout-popup-frame',
  imports: [],
  templateUrl: './popup-frame.component.html',
  styleUrl: './popup-frame.component.scss'
})
export class PopupFrameComponent {
  @Input() isVisible: boolean = false;
  @Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  protected close() {
    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
  }
}
